import { Box, Text } from '@chakra-ui/react'
import { useStore } from '@contexts/store'
import { DisplayUploadCareAsset } from '@hooks/useUploadCare'
import cn from 'classnames'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useState } from 'react'
import { BiListOl } from 'react-icons/bi'
import { FaCheck } from 'react-icons/fa'
import { FiArchive, FiGift } from 'react-icons/fi'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'

function CategoryFilterItem({ className, item, depth = 0 }: any) {
  const router = useRouter()
  const active = router?.query?.tags
  const isActive =
    active === item.slug ||
    item?.children?.some((_item: any) => _item.slug === active)
  const [isOpen, setOpen] = useState<boolean>(isActive)
  useEffect(() => {
    setOpen(isActive)
  }, [isActive])
  const { slug, name, children: items, imageUrl: icon, productCount } = item
  const { displaySidebar, closeSidebar } = useStore()

  const { pathname, query } = router

  const selectedCategories = useMemo(
    () => (query?.category ? (query.category as string).split(',') : []),
    [query?.category],
  )

  function toggleCollapse() {
    setOpen((prevValue) => !prevValue)
  }

  function onClick() {
    if (Array.isArray(items) && !!items.length) {
      toggleCollapse()
    } else {
      const { category, ...restQuery } = query

      let currentFormState = selectedCategories?.includes(slug)
        ? selectedCategories.filter((i) => i !== slug)
        : [...selectedCategories, slug]

      let params: { q?: string; category?: string } = {
        ...restQuery,
        ...(currentFormState.length
          ? { category: currentFormState.join(',') }
          : {}),
      }

      if (slug === 'all') {
        delete params['q']
        delete params['category']
      }
      router.push(
        {
          pathname,
          query: {
            ...params,
          },
        },
        undefined,
        { scroll: false },
      )
      displaySidebar && closeSidebar()
    }
  }

  let expandIcon
  if (Array.isArray(items) && items.length) {
    expandIcon = !isOpen ? (
      <IoIosArrowDown className="text-base text-skin-base text-opacity-40" />
    ) : (
      <IoIosArrowUp className="text-base text-skin-base text-opacity-40" />
    )
  }

  return (
    <>
      <li
        onClick={onClick}
        className={`flex justify-between items-center transition ${
          className
            ? className
            : 'text-sm md:text-15px hover:bg-skin-two border-t border-skin-base first:border-t-0 px-3.5 2xl:px-4 py-3 xl:py-3.5 2xl:py-2.5 3xl:py-3'
        } ${isOpen ? 'bg-skin-two' : 'text-skin-base text-opacity-70'}`}
      >
        <button
          className={cn(
            'flex items-center w-full text-start outline-none focus:outline-none focus:ring-0 focus:text-skin-base',
          )}
        >
          <Box
            mr={2}
            w={10}
            h={10}
            position={'relative'} 
            overflow="hidden"
            className="flex-shrink-0 items-center justify-center rounded-full"
          >
            {icon ? (
              <DisplayUploadCareAsset
                src={icon ?? '/assets/placeholder/category-small.svg'}
                type={'IMAGE'}
                dimensions={{ width: 40, height: 40 }}
                options={{ resize: '100x100' }}
                alt={name || 'Category'}
              />
            ) : (
              <>
                {item?.type ? (
                  item?.slug === 'all' ? (
                    <BiListOl
                      className="text-skin-base text-opacity-40"
                      size={25}
                      style={{
                        opacity: 0.4,
                      }}
                    />
                  ) : (
                    <FiGift
                      className="text-skin-base text-opacity-40"
                      size={25}
                      style={{
                        opacity: 0.4,
                      }}
                    />
                  )
                ) : (
                  <FiArchive
                    className="text-skin-base text-opacity-40"
                    size={25}
                    style={{
                      opacity: 0.4,
                    }}
                  />
                )}
              </>
            )}
          </Box>

          <Text
            as="span"
            textTransform={'capitalize'}
            className="text-skin-base capitalize ps-2.5 md:ps-4 2xl:ps-3 3xl:ps-4"
          >
            {(name?.length > 20
              ? `${name?.slice(0, 20)}...`
              : name
            ).toLowerCase()}
          </Text>
          <Text as="span" ms={'auto'}>
            {/* {expandIcon}
            {productCount > 0 && (
              <Badge colorScheme={'primary'}>{productCount}</Badge>
            )} */}
            {slug !== 'all' && (
              <Text
                as="span"
                className={`w-[22px] h-[22px] text-13px flex items-center justify-center border-2 border-skin-four rounded-full ms-auto transition duration-500 ease-in-out group-hover:border-skin-yellow text-skin-inverted`}
                borderColor={`${selectedCategories?.includes(slug) && 'brand'}`}
                bg={`${selectedCategories?.includes(slug) && 'brand'}`}
              >
                {selectedCategories?.includes(slug) && (
                  <FaCheck color="white" />
                )}
              </Text>
            )}
          </Text>
        </button>
      </li>
    </>
  )
}

function CategoryFilterMenu({ items, className }: any) {
  return (
    <ul className={cn(className)}>
      {items?.map((item: any) => (
        <CategoryFilterItem key={`${item.slug}-key-${item.id}`} item={item} />
      ))}
    </ul>
  )
}

export default CategoryFilterMenu
